//NPM Packages
import { React, useContext, useEffect, useState } from "react";
import axios from "axios";
import styled from "styled-components";

//Context
import MyContext from "../../context/MyContext";

//Components
import Loader from "../styles/Loader.styled";

//Styled Components
import { Input } from "../styles/Input.styled";

//React Icons
import { CiCircleCheck } from "react-icons/ci";
import { CiCircleMore } from "react-icons/ci";
import { CiCircleRemove } from "react-icons/ci";

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  margin-top: 1rem;
`;

const FormSubHeading = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const FormBody = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: large;
`;

const FormWrapper = styled.div``;

const Label = styled.label`
  padding: ${(props) => props.theme.space[1]};
  font-size: medium;
`;

const InputWrapper = styled.div`
  padding: 0 1% 0 0;
`;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  border: 1px solid #bbb;
  border-radius: 3px;
`;

const ValidationMessage = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: small;
  color: red;
`;

const UploadHistoryWrapper = styled.div`
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[1]} 0;
  border-top: 2px solid #ddd;
`;

const UploadHistoryTitle = styled.div`
  font-size: large;
  font-weight: bold;
  padding: ${(props) => props.theme.space[1]};
  margin-bottom: ${(props) => props.theme.space[1]};
`;

const UploadHistoryItem = styled.div`
  display: flex;
  align-items: center;
  padding: ${(props) => props.theme.space[1]};
  margin: ${(props) => props.theme.space[0]};
  font-size: medium;
  border-bottom: 1px solid #eee;
`;

export default function Docs(props) {
  const {
    dev,
    data,
    setData,
    headers,
    idDocData,
    setIdDocData,
    proofOfAddressData,
    setProofOfAddressData,
    proofOfIncomeData,
    setProofOfIncomeData,
    bankStatementData,
    setBankStatementData,
  } = useContext(MyContext);

  // Upload state
  const [isUploading, setIsUploading] = useState(false);
  const [currentUploadType, setCurrentUploadType] = useState("");

  // Upload history - array of successfully uploaded documents
  const [uploadHistory, setUploadHistory] = useState([]);

  // Error messages
  const [idDocSizeError, setIdDocSizeError] = useState("");
  const [proofOfAddressDocSizeError, setProofOfAddressDocSizeError] =
    useState("");
  const [proofOfIncomeDocSizeError, setProofOfIncomeDocSizeError] =
    useState("");
  const [bankStatementSizeError, setBankStatementSizeError] = useState("");
  const [uploadError, setUploadError] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const clearFiles = () => {
    setData((prevValue) => {
      return {
        ...prevValue,
        idDoc: "",
        proofOfAddress: "",
        proofOfIncome: "",
        bankStatements: "",
      };
    });
  };

  const clearDocumentData = () => {
    setIdDocData({
      name: "",
      base64: null,
    });
    setProofOfAddressData({
      name: "",
      base64: null,
    });
    setProofOfIncomeData({
      name: "",
      base64: null,
    });
    setBankStatementData({
      name: "",
      base64: null,
    });
  };

  const handleIdDocChange = (event) => {
    const { name, value } = event.target;
    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });

    if (event.target.files[0]) {
      let fileName = event.target.files[0].name;
      let file = event.target.files[0];

      if (file.size > 3309765) {
        setIdDocSizeError("Please select a file smaller than 3MB");
      } else {
        setIdDocSizeError("");
        fileToBase64(file, (err, result) => {
          if (result) {
            const base64 = result.replace(`data:${file.type};base64,`, "");
            setIdDocData({
              name: fileName,
              base64: base64,
            });
          } else {
            console.log(err);
          }
        });
      }
    } else {
      setIdDocSizeError("");
      setIdDocData({
        name: "",
        base64: null,
      });
    }
  };

  const handleProofOfAddressChange = (event) => {
    const { name, value } = event.target;
    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });

    if (event.target.files[0]) {
      const fileName = event.target.files[0].name;
      const file = event.target.files[0];

      if (file.size > 3309765) {
        setProofOfAddressDocSizeError("Please select a file smaller than 3MB");
      } else {
        setProofOfAddressDocSizeError("");
        fileToBase64(file, (err, result) => {
          if (result) {
            const base64 = result.replace(`data:${file.type};base64,`, "");
            setProofOfAddressData({
              name: fileName,
              base64: base64,
            });
          } else {
            console.log(err);
          }
        });
      }
    } else {
      setProofOfAddressDocSizeError("");
      setProofOfAddressData({
        name: "",
        base64: null,
      });
    }
  };

  const handleProofOfIncomeChange = (event) => {
    const { name, value } = event.target;

    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });

    if (event.target.files[0]) {
      const fileName = event.target.files[0].name;
      const file = event.target.files[0];
      if (file.size > 3309765) {
        setProofOfIncomeDocSizeError("Please select a file smaller than 3MB");
      } else {
        setProofOfIncomeDocSizeError("");
        fileToBase64(file, (err, result) => {
          if (result) {
            const base64 = result.replace(`data:${file.type};base64,`, "");
            setProofOfIncomeData({
              name: fileName,
              base64: base64,
            });
          } else {
            console.log(err);
          }
        });
      }
    } else {
      setProofOfIncomeDocSizeError("");
      setProofOfIncomeData({
        name: "",
        base64: null,
      });
    }
  };

  const handleBankStatementsChange = (event) => {
    const { name, value } = event.target;

    setData((prevValue) => {
      return {
        ...prevValue,
        [name]: value,
      };
    });

    if (event.target.files[0]) {
      const fileName = event.target.files[0].name;
      const file = event.target.files[0];
      if (file.size > 3309765) {
        setBankStatementSizeError("Please select a file smaller than 3MB");
      } else {
        setBankStatementSizeError("");
        fileToBase64(file, (err, result) => {
          if (result) {
            const base64 = result.replace(`data:${file.type};base64,`, "");
            setBankStatementData({
              name: fileName,
              base64: base64,
            });
          } else {
            console.log(err);
          }
        });
      }
    } else {
      setBankStatementSizeError("");
      setBankStatementData({
        name: "",
        base64: null,
      });
    }
  };

  // Convert file to base64 string
  const fileToBase64 = (file, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(null, reader.result);
    };
    reader.onerror = function (error) {
      console.log("Error: ", error);
      cb(error, null);
    };
  };

  // Upload a single document to the API
  const uploadDocument = async (docType, docName, docBase64, displayName) => {
    const payload = {
      leadId: data.leadId,
    };

    // Add the appropriate field name based on document type
    if (docType === "idDoc") {
      payload.idDocName = docName;
      payload.idDocBase64 = docBase64;
    } else if (docType === "proofOfAddress") {
      payload.proofOfAddressName = docName;
      payload.proofOfAddressBase64 = docBase64;
    } else if (docType === "proofOfIncome") {
      payload.proofOfIncomeName = docName;
      payload.proofOfIncomeBase64 = docBase64;
    } else if (docType === "bankStatement") {
      payload.bankStatementName = docName;
      payload.bankStatementBase64 = docBase64;
    }

    try {
      const response = await axios.post(
        dev ? "http://localhost:5000/api/docs" : "api/docs",
        payload,
        {
          headers: headers,
        }
      );

      if (response.status === 200) {
        console.log(`${displayName} uploaded successfully`);
        return { success: true, fileName: docName, type: displayName };
      } else {
        console.log(`${displayName} upload failed: ${response.status}`);
        return { success: false, fileName: docName, type: displayName };
      }
    } catch (error) {
      console.log(`${displayName} upload error:`, error);
      return { success: false, fileName: docName, type: displayName };
    }
  };

  // Main submit function that handles sequential uploads
  const submitDocs = async () => {
    // Clear any previous upload errors
    setUploadError("");

    // Build array of documents to upload
    const docsToUpload = [];

    if (idDocData.name && idDocData.base64) {
      docsToUpload.push({
        type: "idDoc",
        name: idDocData.name,
        base64: idDocData.base64,
        displayName: "ID Document",
      });
    }

    if (proofOfAddressData.name && proofOfAddressData.base64) {
      docsToUpload.push({
        type: "proofOfAddress",
        name: proofOfAddressData.name,
        base64: proofOfAddressData.base64,
        displayName: "Proof of Address",
      });
    }

    if (proofOfIncomeData.name && proofOfIncomeData.base64) {
      docsToUpload.push({
        type: "proofOfIncome",
        name: proofOfIncomeData.name,
        base64: proofOfIncomeData.base64,
        displayName: "Proof of Income",
      });
    }

    if (bankStatementData.name && bankStatementData.base64) {
      docsToUpload.push({
        type: "bankStatement",
        name: bankStatementData.name,
        base64: bankStatementData.base64,
        displayName: "Bank Statement",
      });
    }

    // Check if any documents are selected
    if (docsToUpload.length === 0) {
      setUploadError("Please select at least one document to upload.");
      return;
    }

    // Check if leadId exists
    if (!data.leadId) {
      setUploadError(
        "Lead ID is missing. Please complete the previous steps first."
      );
      return;
    }

    setIsUploading(true);

    // Upload documents sequentially
    for (const doc of docsToUpload) {
      setCurrentUploadType(doc.displayName);

      const result = await uploadDocument(
        doc.type,
        doc.name,
        doc.base64,
        doc.displayName
      );

      if (result.success) {
        // Add to upload history
        setUploadHistory((prev) => [
          ...prev,
          {
            fileName: result.fileName,
            type: result.type,
            timestamp: new Date().toLocaleString(),
            status: "success",
          },
        ]);
      } else {
        // Add to upload history with error status
        setUploadHistory((prev) => [
          ...prev,
          {
            fileName: result.fileName,
            type: result.type,
            timestamp: new Date().toLocaleString(),
            status: "error",
          },
        ]);
        setUploadError(
          `Failed to upload ${result.type}. Please try again or contact us on ${props.phone}.`
        );
      }
    }

    setIsUploading(false);
    setCurrentUploadType("");

    // Clear file inputs and document data after all uploads complete
    clearFiles();
    clearDocumentData();
  };

  return (
    <div>
      <FormWrapper>
        <FormBody>
          <ItemWrapper>
            <Label>ID Document</Label>
            <InputWrapper>
              <Input
                type="file"
                name="idDoc"
                onChange={handleIdDocChange}
                required={false}
                value={data.idDoc}
                width="100%"
                disabled={isUploading}
              />
            </InputWrapper>
            {idDocSizeError && (
              <ValidationMessage>{idDocSizeError}</ValidationMessage>
            )}
          </ItemWrapper>
          <ItemWrapper>
            <Label>Proof Of Address</Label>
            <InputWrapper>
              <Input
                type="file"
                name="proofOfAddress"
                onChange={handleProofOfAddressChange}
                required={false}
                value={data.proofOfAddress}
                width="100%"
                disabled={isUploading}
              />
            </InputWrapper>
            {proofOfAddressDocSizeError && (
              <ValidationMessage>
                {proofOfAddressDocSizeError}
              </ValidationMessage>
            )}
          </ItemWrapper>
          <ItemWrapper>
            <Label>Latest Payslip</Label>
            <InputWrapper>
              <Input
                type="file"
                name="proofOfIncome"
                onChange={handleProofOfIncomeChange}
                required={false}
                value={data.proofOfIncome}
                width="100%"
                disabled={isUploading}
              />
            </InputWrapper>
            {proofOfIncomeDocSizeError && (
              <ValidationMessage>{proofOfIncomeDocSizeError}</ValidationMessage>
            )}
          </ItemWrapper>
        </FormBody>
        <ButtonWrapper>
          <button
            className="btn btn-dark btn-md"
            type="button"
            style={{ margin: "0 2px" }}
            onClick={submitDocs}
            disabled={isUploading}
          >
            {isUploading ? "Uploading..." : "Submit Docs"}
          </button>
        </ButtonWrapper>
      </FormWrapper>

      {uploadError && (
        <FormSubHeading style={{ color: "red" }}>
          <CiCircleRemove style={{ color: "red" }} /> {uploadError}
        </FormSubHeading>
      )}

      {isUploading && currentUploadType && (
        <FormSubHeading>
          <Loader />
          <CiCircleMore /> Submitting your {currentUploadType}, please stand
          by...
        </FormSubHeading>
      )}

      {uploadHistory.length > 0 && (
        <UploadHistoryWrapper>
          <UploadHistoryTitle>Upload History</UploadHistoryTitle>
          {uploadHistory.map((upload, index) => (
            <UploadHistoryItem key={index}>
              {upload.status === "success" ? (
                <CiCircleCheck style={{ color: "green", marginRight: "8px" }} />
              ) : (
                <CiCircleRemove style={{ color: "red", marginRight: "8px" }} />
              )}
              <span>
                <strong>{upload.type}:</strong> {upload.fileName} -{" "}
                {upload.timestamp}
              </span>
            </UploadHistoryItem>
          ))}
        </UploadHistoryWrapper>
      )}
    </div>
  );
}
